(function(angular){
	'use strict';
	
	angular
		.module('modalModule')
		.controller('StandardModalController', [
			'$compile',
			'$rootScope',
			'$sce',
			'$timeout',
			'APP_BASE_PATH',
			'STATIC_BASE_PATH',
			'inputs',
			'close',
			'ignoreClose',
			StandardModalFunction
		]);
	
	function StandardModalFunction(
		$compile,
		$rootScope,
		$sce,
		$timeout,
		APP_BASE_PATH,
		STATIC_BASE_PATH,
		inputs,
		close,
		ignoreClose
	){
		var standardModal = this;
		
		var modalContentScope = $rootScope.$new();
		modalContentScope.standardModal = {
			APP_BASE_PATH: APP_BASE_PATH,
			STATIC_BASE_PATH: STATIC_BASE_PATH	
		};
			
		modalContentScope.standardModal = angular.merge(modalContentScope.standardModal, inputs.params);

		var compiled = $compile(inputs.content)(modalContentScope); 
		standardModal.title = inputs.title; 
		$timeout(function() {
			standardModal.compiledContent = $sce.trustAsHtml(compiled[0].outerHTML);
		});
		standardModal.close = close;
		standardModal.ignoreClose = ignoreClose;
	}
})(window.angular);